import { Component,OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';
@Component({
  selector: 'app-ecommerce',
  templateUrl: './ecommerce.component.html',
  styleUrls: ['./ecommerce.component.scss']
})
export class EcommerceComponent implements OnInit {
  
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('E-Commerce');
  
    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }
}
